export function determineNewLevel(currentLevel, incorrectAttempts) {
    if (incorrectAttempts === 0) {
        // Correct answer, increase level (max 8)
        if (currentLevel < 8) return currentLevel + 1;
        return 8; // Level remains maxed out
    } else {
        // Incorrect answer logic
        if (incorrectAttempts === 1) {
            return Math.max(1, currentLevel - 1);
        } else if (incorrectAttempts >= 2) {
            if (currentLevel >= 2 && currentLevel <= 5) {
                return 1;
            } else if (currentLevel >= 6 && currentLevel <= 7) {
                return 4;
            } else if (currentLevel > 7) {
                return 7; // Unburn scenario
            }
        }
    }
    return currentLevel; // Default fallback (shouldn't be hit)
}
